const kindMeta = {
  influencers: {
    label: "Creators",
    paletteKey: "primary",
    icon: ({ color }) => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    moreLink: "/shops",
  },
  products: {
    label: "Products",
    paletteKey: "secondary",
    icon: ({ color }) => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      >
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    ),
    moreLink: "/products",
  },
  characters: {
    label: "Characters",
    paletteKey: "purple",
    icon: ({ color }) => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    ),
    moreLink: null,
  },
  franchises: {
    label: "Franchises",
    paletteKey: "green",
    icon: ({ color }) => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="21" x2="9" y2="9" />
      </svg>
    ),
    moreLink: null,
  },
  collections: {
    label: "Collections",
    paletteKey: "primary",
    icon: ({ color }) => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
    moreLink: null,
  },
  results: {
    label: "Top Results",
    paletteKey: "secondary",
    icon: ({ color }) => (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
    moreLink: null,
  },
};

/**
 * Resolves the accent color for a kind via CSS custom properties.
 *
 * Palette mapping:
 *   primary   -> var(--md-primary)
 *   secondary -> var(--md-secondary)
 *   purple    -> var(--accent-purple)
 *   green     -> var(--status-success)
 */
export function getAccentColor(paletteKey) {
  switch (paletteKey) {
    case "primary":
      return "var(--md-primary)";
    case "secondary":
      return "var(--md-secondary)";
    case "purple":
      return "var(--accent-purple)";
    case "green":
      return "var(--status-success)";
    default:
      return "var(--text)";
  }
}

export function countResults({
  influencers = [],
  products = [],
  franchises = [],
  characters = [],
}) {
  return (
    influencers.length + products.length + franchises.length + characters.length
  );
}

export default kindMeta;
